<template>
    <v-flex
        class="blue lighten-5 pa-2 ma-2"
        xs12
        sm6
        md4
        lg3
      >
        <h3>{{item.label}}</h3>
        <v-text-field  v-model="item.label" :label="item.label + ' label'" box required></v-text-field>
        <v-textarea
          v-model="item.description"
          :label="item.label + ' description'"
          box
          auto-grow
          required
        ></v-textarea>
        <img class="img-measure" :src="url" alt="">
        <!-- <input type="file" :ref="item.id" @change="changeImage(index,item.url, item.id)"> -->
        <v-btn color="error" @click="deleteItem(index)">Delete field</v-btn>
        <input class="inputfile" :id="item.label" type="file" @change="changeImage($event, index)" />
        <button class="v-btn warning">
          <label class="px-1 white--text v-btn__content" :for="item.label">Change Image</label>
        </button>
      </v-flex>
</template>

<script>
export default {
    props:['item', 'index', 'image'],
    data(){
      return {
        url:''
      }
    },
    methods:{
      displayImage(url, image){
        if(url){
           this.url = url;
        }
        else{
          var reader = new FileReader();
          let result;
          reader.readAsDataURL(image);

          reader.onload = e=> {
              console.log(e)
              result = e.target.result;
              return this.url = result;
            }
        }
      },
      deleteItem(index){
          this.$emit('deleteField', index);
      },
      changeImage(event,index){
          this.$emit('changeImage', event,index);
      }   
    },
    created(){
      this.displayImage(this.$props.item.url, this.$props.image);
    }
}
</script>


<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputfile + label {
    color: white;
    background-color: black;
    display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
    background-color: red;
}
.inputfile + label {
	cursor: pointer; /* "hand" cursor */
}
.inputfile:focus + label {
	outline: 1px dotted #000;
	outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label * {
	pointer-events: none;
}
</style>
